import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from './Constants';
import axios from 'axios';


const EnrollmentTable = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    fetchEnrollments();
  }, []);

  const fetchEnrollments = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/api/enrolls`);
      setEnrollments(res.data);
      setError('');
    } catch (err) {
      setError('Failed to fetch enrollments. Please try again.');
      console.error('Error fetching enrollments:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(`${API_BASE_URL}/api/enrolls/${id}`);
      setEnrollments(enrollments.filter(item => item.id !== id));
      setDeleteConfirm(null);
    } catch (err) {
      setError('Failed to delete enrollment. Please try again.');
      console.error('Error deleting enrollment:', err);
    }
  };

  const syllabusOptions = ['CBSE', 'ICSE', 'IGCSE', 'KERALA STATE'];
  const typeOptions = ['ONETOONE', 'GROUP', 'OTHERS'];
  const statusOptions = ['active', 'inactive', 'completed'];

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <span className="loading loading-spinner loading-lg"></span>
        <span className="ml-2">Loading enrollments...</span>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-8">Course List</h1>
      
      {error && (
        <div className="alert alert-error mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{error}</span>
        </div>
      )}
      
      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>ID</th>
              <th>Course</th>
              <th>Tutor ID</th>
              <th>Student ID</th>
              <th>Syllabus</th>
              <th>Grade</th>
              <th>Subject</th>
              <th>Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {enrollments.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No enrollments foundi.
                </td>
              </tr>
            ) : (
              enrollments.map((enrollment) => (
                <tr key={enrollment.id}>
                  <td>{enrollment.id}</td>
                  <td>{enrollment.course_name}</td>
                  <td>{enrollment.tutor.name}</td>
                  <td>{enrollment.student.name}</td>
                  <td>
                    <span className="badge badge-outline">
                      {enrollment.syllabus}
                    </span>
                  </td>
                  <td>{enrollment.grade}</td>
                  <td>{enrollment.subject}</td>
                  <td>
                    <span className="badge badge-ghost">
                      {enrollment.type}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${
                      enrollment.status === 'active' ? 'badge-success' :
                      enrollment.status === 'completed' ? 'badge-info' : 'badge-warning'
                    }`}>
                      {enrollment.status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn btn-error btn-sm"
                      onClick={() => setDeleteConfirm(enrollment.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      
      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div className="modal modal-open">
          <div className="modal-box">
            <h3 className="font-bold text-lg">Confirm Delete</h3>
            <p className="py-4">Are you sure you want to delete this enrollment? This action cannot be undone.</p>
            <div className="modal-action">
              <button className="btn btn-ghost" onClick={() => setDeleteConfirm(null)}>
                Cancel
              </button>
              <button 
                className="btn btn-error" 
                onClick={() => handleDelete(deleteConfirm)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnrollmentTable;